/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyConfiguration {
    getFixupPrototypeFunction() { return CostAnomalyConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyConfiguration>): CostAnomalyConfiguration {
        let obj = Object.assign(new CostAnomalyConfiguration(), model);
        CostAnomalyConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyConfiguration>): CostAnomalyConfiguration {
        if (!model) return null;
        return CostAnomalyConfiguration.newInstance(<CostAnomalyConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyConfiguration) {
        if (!obj) return;

        models.CostAnomalyConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyConfiguration): boolean {
        Object.setPrototypeOf(obj, CostAnomalyConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.threshold_configuration) {
            models.CostAnomalySetting.fixupPrototype(this.threshold_configuration);
        }
        if (this.notifications) {
            for (let val of this.notifications) {
                models.ConfigurationForCostAnomalyNotification.fixupPrototype(val);
            }
        }
    }

    /**
     * threshold configuration.
     */
    threshold_configuration: models.CostAnomalySetting;

    /**
     * Notification configuration.
     */
    notifications: Array<models.ConfigurationForCostAnomalyNotification>;

    /**
     * Base billing metric where the aggregation query will be executed.
     */
    billing_source: models.CostAnomalyBillingMetrics;

}
